import { Link, styled } from "@mui/material";


export const LinkOrderAgreementStyled = styled(Link, {
    label: "OrderOffer-LinkOrderAgreementStyled",
})(({ theme }) => ({
    marginLeft: "5px",
    textDecoration: "underline",
}));
